import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.518 3.7a.7.7 0 0 1 .7-.7H16.3a.7.7 0 0 1 .7.7v9.564A3.736 3.736 0 0 1 13.264 17H3.7a.7.7 0 0 1-.7-.7V7.95a.7.7 0 0 1 .7-.7h.818V3.7Zm1.4 3.55h3.854a.7.7 0 0 1 .7.7v7.65h1.864v-2.564a.7.7 0 0 1 .7-.7H15.6V4.4H5.918v2.85Zm9.634 6.486h-1.816v1.816a2.339 2.339 0 0 0 1.816-1.816ZM9.072 15.6V8.65H4.4v6.95h4.672Zm-3.947-5.372a.7.7 0 0 1 .7-.7h1.822a.7.7 0 1 1 0 1.4H5.825a.7.7 0 0 1-.7-.7Zm0 1.897a.7.7 0 0 1 .7-.7h1.822a.7.7 0 1 1 0 1.4H5.825a.7.7 0 0 1-.7-.7Zm0 1.898a.7.7 0 0 1 .7-.7h1.822a.7.7 0 1 1 0 1.4H5.825a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
